export const loadCart = () => {
  try {
    const data = localStorage.getItem("cart");
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
};

export const saveCart = (cartItems) => {
  localStorage.setItem("cart", JSON.stringify(cartItems));
};
